import React from "react";

import { Box } from "@mui/material";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";

/**
 * The option renderer every autocomplete on this form shares: the part of the label matching what has
 * been typed is bolded and coloured.
 *
 * One helper rather than the same twenty lines in four places — `DetailsStep` repeats it per field and
 * they have already drifted (the crime picker colours the match, the others only bold it, and the
 * bulletin-type field bolds the whole option on an exact match instead of highlighting a substring).
 *
 * The colour is `primary.main`; the production copies hardcode `blue`.
 */
export const renderHighlightedOption = (
  {
    key,
    ...optionProps
  }: React.HTMLAttributes<HTMLLIElement> & { key?: React.Key },
  label: string,
  inputValue: string,
): React.ReactNode => {
  const parts = parse(label, match(label, inputValue, { insideWords: true }));

  return (
    <li key={key} {...optionProps}>
      <span>
        {parts.map((part, index) => (
          <Box
            key={index}
            component="span"
            sx={{
              fontWeight: part.highlight ? 700 : 400,
              color: part.highlight ? "primary.main" : "inherit",
            }}
          >
            {part.text}
          </Box>
        ))}
      </span>
    </li>
  );
};
